import { useState, useEffect } from "react";
import { ColumnInstance } from "react-table";
import { TableRow } from "./types";
import clsx from "clsx";

export const TableHeaderFilterField: React.FC<{
  column: ColumnInstance<TableRow>;
  className?: string;
}> = ({ column, className }) => {
  const [inputValue, setInputValue] = useState(column.filterValue || "");

  // Keep local input in sync with react-table filter value
  useEffect(() => {
    setInputValue(column.filterValue || "");
  }, [column.filterValue]);

  // Debounce updating react-table filter
  useEffect(() => {
    const handler = setTimeout(() => {
      if (inputValue !== column.filterValue) {
        column.setFilter(inputValue || undefined);
      }
    }, 250);

    return () => clearTimeout(handler);
  }, [inputValue, column]);

  return (
    <input
      value={inputValue}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => setInputValue(e.target.value)}
      className={clsx(
        "h-7 rounded border-0 border-dm-charcoal-500 px-2 text-sm text-dm-charcoal-500 outline-none ring-dm-charcoal-200 focus:border focus:ring-1",
        className
      )}
      placeholder="Search"
    />
  );
};
